import script from "./TermsAndConditionsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsAndConditionsView.vue?vue&type=script&setup=true&lang=ts"

import "./TermsAndConditionsView.vue?vue&type=style&index=0&id=206bd01a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-206bd01a"]])

export default __exports__